<template>
  <div v-if="menuItems">
    <div v-on:click="addNewItem">add item aaa</div>
    ddl-multiple<br />
    <vue-nestable v-model="menuItemsLocal">
      <vue-nestable-handle slot-scope="{ item }" :item="item">
        {{ item.text }}
      </vue-nestable-handle>
    </vue-nestable>
  </div>
</template>
<script>
import en from "./admin-en.json";
import fr from "./admin-fr.json";
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-menuItem",
  mixins: [helpers],
  beforeMount() {
    this.$i18n.add("fr", fr);
    this.$i18n.add("en", en);
  },
  data: function() {
    return {};
  },
  props: {
    menuItems: { type: Array }
  },
  model: {
    prop: "menuItems",
    event: "menuItems:change"
  },
  mounted() {},
  watch: {},
  computed: {
    menuItemsLocal: {
      get() {
        return this.menuItems;
      },
      set(value) {
        this.$emit("menuItems:change", value);
      }
    }
  },
  methods: {
    addNewItem() {
      let id = this.menuItemsLocal.length + 1;
      this.menuItemsLocal.push({
        id: id,
        text: `Added item #${id}`,
        children: []
      });
    }
  }
};
</script>
<style>
/*
* Style for nestable
*/
.nestable {
  position: relative;
}
.nestable-rtl {
  direction: rtl;
}
.nestable .nestable-list {
  margin: 0;
  padding: 0 0 0 40px;
  list-style-type: none;
}
.nestable-rtl .nestable-list {
  padding: 0 40px 0 0;
}
.nestable > .nestable-list {
  padding: 0;
}
.nestable-item,
.nestable-item-copy {
  margin: 10px 0 0;
}
.nestable-item:first-child,
.nestable-item-copy:first-child {
  margin-top: 0;
}
.nestable-item .nestable-list,
.nestable-item-copy .nestable-list {
  margin-top: 10px;
}
.nestable-item {
  position: relative;
}
.nestable-item.is-dragging .nestable-list {
  pointer-events: none;
}
.nestable-item.is-dragging * {
  opacity: 0;
  filter: alpha(opacity=0);
}
.nestable-item.is-dragging:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(106, 127, 233, 0.274);
  border: 1px dashed rgb(73, 100, 241);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.nestable-drag-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  pointer-events: none;
}
.nestable-rtl .nestable-drag-layer {
  left: auto;
  right: 0;
}
.nestable-drag-layer > .nestable-list {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  background-color: rgba(106, 127, 233, 0.274);
}
.nestable-rtl .nestable-drag-layer > .nestable-list {
  padding: 0;
}
.nestable [draggable="true"] {
  cursor: move;
}
.nestable-handle {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// components/Custom/MenuItem/menuItem.vue